module.exports = __webpack_public_path__ + "static/img/doc_11.afcb793d.png";